/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

/*
 * Copyright (c) 2026. Orion Analytics.
 * All Rights Reserved.
 */

import { useMemo } from "react";
import Plot from "react-plotly.js";
import MetricHelp from "../common/MetricHelp";

export default function PCRDashboard({ data }) {

    const latest = data?.pcr_latest || [];
    const history = data?.pcr_history || [];

    const niftyHistory = useMemo(() => {

        return history.filter(
            x => x.symbol === "NIFTY"
        );

    }, [history]);
    console.log('INSIDE PCR DASHBOARD - NIFTY DATA ->',niftyHistory)
    const bankNiftyHistory = useMemo(() => {

        return history.filter(
            x => x.symbol === "BANKNIFTY"
        );

    }, [history]);

    const highestPCR = useMemo(() => {

        return [...latest]
            .sort(
                (a, b) =>
                    Number(b.total_pcr) -
                    Number(a.total_pcr)
            )
            .slice(0, 10);

    }, [latest]);

    const lowestPCR = useMemo(() => {

        return [...latest]
            .sort(
                (a, b) =>
                    Number(a.total_pcr) -
                    Number(b.total_pcr)
            )
            .slice(0, 10);

    }, [latest]);

    const niftyLatest =
        latest.find(
            x => x.symbol === "NIFTY"
        );

    const bankLatest =
        latest.find(
            x => x.symbol === "BANKNIFTY"
        );

    return (

        <div className="space-y-6">

            {/* SNAPSHOT CARDS */}

            <div className="
                grid
                grid-cols-1
                md:grid-cols-2
                lg:grid-cols-4
                gap-4
            ">

                <PCRCard
                    title="NIFTY PCR"
                    value={
                        niftyLatest?.total_pcr
                    }
                />

                <PCRCard
                    title="BANKNIFTY PCR"
                    value={
                        bankLatest?.total_pcr
                    }
                />

                <PCRCard
                    title="Highest PCR"
                    value={
                        highestPCR[0]?.symbol +
                        " (" +
                        Number(
                            highestPCR[0]?.total_pcr
                        ).toFixed(2) +
                        ")"
                    }
                />

                <PCRCard
                    title="Lowest PCR"
                    value={
                        lowestPCR[0]?.symbol +
                        " (" +
                        Number(
                            lowestPCR[0]?.total_pcr
                        ).toFixed(2) +
                        ")"
                    }
                />
            </div>

            {/* TREND CHART */}

            <div className="
                bg-slate-950
                rounded-3xl
                border
                border-slate-800
                p-4
            ">

                <h3 className="
                    text-white
                    text-lg
                    font-semibold
                    mb-4
                ">
                    PCR Trend
                </h3>

                <Plot

                    data={[

                        {
                            x:
                                niftyHistory.map(
                                    x => x.timestamp
                                ),

                            y:
                                niftyHistory.map(
                                    x =>
                                        Number(
                                            x.total_pcr
                                        )
                                ),

                            type: "scatter",

                            mode: "lines",

                            name: "NIFTY"
                        },

                        {
                            x:
                                bankNiftyHistory.map(
                                    x => x.timestamp
                                ),

                            y:
                                bankNiftyHistory.map(
                                    x =>
                                        Number(
                                            x.total_pcr
                                        )
                                ),

                            type: "scatter",

                            mode: "lines",

                            name: "BANKNIFTY"
                        }

                    ]}

                    layout={{

                        height: 500,

                        paper_bgcolor:
                            "#020617",

                        plot_bgcolor:
                            "#020617",

                        font: {
                            color:
                                "#cbd5e1"
                        },

                        xaxis: {
                            type: "date"
                        },

                        yaxis: {
                            title:
                                "PCR"
                        },

                        legend: {
                            orientation:
                                "h"
                        }

                    }}

                    config={{
                        responsive: true,
                        displayModeBar: false
                    }}

                    style={{
                        width: "100%"
                    }}

                />

            </div>

            {/* EXTREME PCR TABLES */}

            <div className="
                grid
                grid-cols-1
                xl:grid-cols-2
                gap-6
            ">

                <PCRTable
                    title="Highest PCR"
                    rows={highestPCR}
                />

                <PCRTable
                    title="Lowest PCR"
                    rows={lowestPCR}
                />

            </div>

        </div>

    );

}

function PCRCard({
    title,
    value
}) {

    return (

        <div className="
            bg-slate-950
            border
            border-slate-800
            rounded-3xl
            p-5
        ">

            <div className="
                text-slate-400
                text-sm
            ">
                {title}
            </div>

            <div className="
                text-2xl
                font-bold
                text-white
                mt-2
            ">
                {value ?? "-"}
            </div>

        </div>

    );

}

function PCRTable({
    title,
    rows
}) {

    return (

        <div className="
            bg-slate-950
            border
            border-slate-800
            rounded-3xl
            p-4
        ">

            <h3 className="
                text-white
                font-semibold
                mb-4
            ">
                {title}
            </h3>

            <table className="
                w-full
                text-sm
            ">

                <thead>

                    <tr className="
                        text-slate-400
                        border-b
                        border-slate-800
                    ">

                        <th className="
                            text-left
                            py-2
                        ">
                            Symbol
                        </th>

                        <th className="
                            text-right
                            py-2
                        ">
                            PCR
                        </th>

                    </tr>

                </thead>

                <tbody>

                    {rows.map(
                        row => (

                            <tr
                                key={row.symbol}
                                className="
                                    border-b
                                    border-slate-900
                                "
                            >

                                <td className="
                                    py-2
                                    text-slate-200
                                ">
                                    {row.symbol}
                                </td>

                                <td className="
                                    py-2
                                    text-right
                                    text-white
                                ">
                                    {Number(
                                        row.total_pcr
                                    ).toFixed(2)}
                                </td>

                            </tr>

                        )
                    )}

                </tbody>

            </table>

        </div>

    );

}